import proxy from "../proxy";
const user = {
  otp: (data, history) => async (dispatch) =>
    await proxy.login("public/sendOTP", data, { history, dispatch }),
  // otp:
  //   (data = {}) =>
  //   async (dispatch) =>
  //     dispatch({ type: "public/sendOTP", payload: data }),
  otp_login: (data, history) => async (dispatch) =>
    await proxy.login("user/otp/login", data, { history, dispatch }),
  // otp_login:
  //   (data = {}) =>
  //   async (dispatch) =>
  //     dispatch({ type: "user/otp/login", payload: data }),
  register: (data, history) => async (dispatch) =>
    await proxy.login("user/register", data, { history, dispatch }),
  switchRole: (data, history) => async (dispatch) =>
    await proxy.login("user/switchRole", data, { history, dispatch }),
  logout: (data, history) => async (dispatch) =>
    await proxy.logout("user/logout", data, { history, dispatch }),
  getUserRole: (data) => async (dispatch) =>
    await proxy.get("user/getUserRole", data, { dispatch }),
  list:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("user/list", data, { dispatch }),
  domains:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("user/domains", data, { dispatch }),
  getmothers:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get2("mothers/list", data, {
        dispatch,
      }),
  getProfile:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("user/getProfile", data, { dispatch }),
  setProfile:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.put("user/setProfile", data, { dispatch });
      await proxy.get("user/getProfile", data2, { dispatch });
    },
  add:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.post("user/add", data);
      await proxy.get("user/list", data2, { dispatch });
    },
  del:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.delete("user/delete", data);
      await proxy.get("user/list", data2, { dispatch });
    },
};

export default user;
